import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initCloudTerminal(): void {
    const terminal = document.querySelector('.terminal-body');
    if (!terminal) return;

    const codes = terminal.querySelectorAll('code');
    gsap.set(codes, { opacity: 0, x: -10 });

    ScrollTrigger.create({
        trigger: '.cloud-infra',
        start: 'top 60%',
        onEnter: () => {
            gsap.to(codes, {
                opacity: 1,
                x: 0,
                stagger: 0.2,
                duration: 0.4,
                ease: 'power2.out'
            });
        },
        once: true
    });
}

export function initCloudNodes(): void {
    const nodes = document.querySelectorAll('.cloud-node');
    if (nodes.length === 0) return;

    nodes.forEach((node) => {
        // Floating motion with slight randomness
        gsap.to(node, {
            x: '+=30',
            y: '+=20',
            duration: 3 + Math.random() * 2,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut'
        });
    });
}
